// add function for numbers to to round to however many places you provide
//only rounds as needed. Does not add decimal places for whole numbers
export const decimalRoundHelper = (num, places = 2) => {
  places = Math.pow(10, places);
  return Math.round(num * places) / places;
};

export function getWindowSize() {
  const { innerWidth, innerHeight } = window;
  return { innerWidth, innerHeight };
}

export const convertToINS = (value) => {
  const quantifiers = {
    1: 'K',
    2: 'M',
    3: 'B'
  }
  let cnt = 0;
  while (value >= 1000) {
    value /= 1000;
    cnt += 1
  }
  return value.toString() + quantifiers[cnt];
};